var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2853",
    "data-name": "Rectangle 2853",
    width: 28,
    height: 23,
    fill: "#ff4d4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M13.514,22.327a2.3,2.3,0,0,1-.688-1.633,2.275,2.275,0,0,1,.688-1.621l5.355-5.289a1.083,1.083,0,0,1-.2.011H9.337a2.3,2.3,0,1,1,0-4.6h9.334a1.083,1.083,0,0,1,.2.011L13.514,3.93a2.28,2.28,0,0,1,0-3.254,2.362,2.362,0,0,1,3.3,0l9.334,9.2a2.28,2.28,0,0,1,0,3.254l-9.334,9.2a2.362,2.362,0,0,1-3.3,0",
    transform: "translate(1.168 0)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M0,16.865V6.133A6.186,6.186,0,0,1,6.222,0H8.167A2.318,2.318,0,0,1,10.5,2.3,2.317,2.317,0,0,1,8.167,4.6H6.222A1.547,1.547,0,0,0,4.667,6.133V16.865A1.546,1.546,0,0,0,6.222,18.4H8.167a2.3,2.3,0,1,1,0,4.6H6.222A6.185,6.185,0,0,1,0,16.865",
    transform: "translate(0 -0.001)",
    fill: "#ff4d4d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.507b7d77d5243c90571df237c7bd51e3.svg";
export { ForwardRef as ReactComponent };